export const FETCH_KITCHEN_ORDERS = "FETCH_KITCHEN_ORDERS";
export const FETCH_KITCHEN_ORDERS_SUCCESS = "FETCH_KITCHEN_ORDERS_SUCCESS";
export const FETCH_KITCHEN_ORDERS_FAILURE = "FETCH_KITCHEN_ORDERS_FAILURE";
export const MARK_KITCHEN_ORDER_SERVED = "MARK_KITCHEN_ORDER_SERVED";
export const MARK_KITCHEN_ORDER_SERVED_SUCCESS =
  "MARK_KITCHEN_ORDER_SERVED_SUCCESS";
export const MARK_KITCHEN_ORDER_SERVED_FAILURE =
  "MARK_KITCHEN_ORDER_SERVED_FAILURE";
